// Unpublished Work © 2022-2024 Deere & Company.

const PARTS_CATALOG_URL = 'https://partscatalog.deere.com/jdrc/search';
const SHOP_URL = 'https://shop.deere.com/us/search';

export {
    PARTS_CATALOG_URL,
    SHOP_URL
};
